import styled from "styled-components";

export const StyledMasterBalancesWrapper = styled.div`
 position: relative;

 .master-balances-head {
  padding: 15px 0 25px;
  display: grid;
  align-items: center;
  grid-template-columns: max-content 175px;
  grid-gap: 20px;
  @media screen and (max-width: 576px) {
   grid-template-columns: 100%;
  }
 }

 .master-balances-table {
  &__head, &__row {
   grid-template-columns: repeat(3, minmax(0, 1fr)) 390px;
  }

  &__actions {
   display: grid;
   grid-template-columns: repeat(2, 1fr);
   grid-gap: 10px;
   
   button {
    width: 100%;
   }
  }
 }
`;

export const StyledMasterBalancesHistoryWrapper = styled.div``;

export const StyledSwitchWrapper = styled.div``;